import React from 'react';
import { DefaultShipping } from '../partials/shipping/DefaultShipping';
import { EmptyShippingMessage } from '../partials/shipping/EmptyShippingMessage';
import { GCC_COUNTER_TOPS } from '../../components/constants';
import {
  getShippingThreshold,
  getSellableQuantityYourStore,
  isAppliance,
  isBackorderedWithDate,
  isBackordered,
  isBODFS,
  isDiscontinued,
  hasFreeShipping,
  isLiveGoods,
  isNextDayDelivery,
  isOutOfStockOnline,
  isSameDayDelivery,
  isSTH,
  shouldShowShippingThreshold,
  meetsApplianceDeliveryThreshold,
  applianceDeliveryThreshold,
  getDisplayableInventory
} from './pod-fulfillment-utils';
import { dataModel } from '../../components/dataModel';

export const getShippingTemplate = ({ product, customer }) => {

  const isGCCCounter = product?.info?.globalCustomConfigurator?.customExperience === GCC_COUNTER_TOPS;

  const displayQuantity = getDisplayableInventory(product, customer);

  const getThresholdShipping = getShippingThreshold(product);

  if (!product || isGCCCounter) return EmptyShippingMessage;

  /* -----LiveGoods----- */
  if (isLiveGoods(product)) {
    if (!getSellableQuantityYourStore(product)) {
      return EmptyShippingMessage;
    }
  }

  if (isDiscontinued(product)) {
    return () => (
      <DefaultShipping
        shippingMessage="No longer available"
      />
    );
  }

  /* -----Appliance----- */
  if (isAppliance(product)) {
    if (meetsApplianceDeliveryThreshold(product)) {
      return () => (
        <DefaultShipping
          iconType="success"
          shippingMessageStyle="shipping__success"
          shippingMessage="Free"
        />
      );
    }
    return () => (
      <DefaultShipping
        iconType="success"
        shippingMessageStyle="shipping__success"
        shippingMessage={`Free on appliance orders $${applianceDeliveryThreshold()}+`}
      />
    );
  }

  /* -----STH Only----- */
  if (isSTH(product) && !isBODFS(product)) {
    if (isBackorderedWithDate(product) || isBackordered(product)) {
      return () => (
        <DefaultShipping
          iconType="success"
          shippingMessage="Standard"
        />
      );
    }
    if (hasFreeShipping(product)) {
      return () => (
        <DefaultShipping
          iconType="success"
          shippingMessageStyle="shipping__success"
          shippingMessage="Free"
          displayQuantity={displayQuantity}
        />
      );
    }
    if (getThresholdShipping) {
      let shippingThreshold = shouldShowShippingThreshold(product, getThresholdShipping)
        ? getThresholdShipping : 0;
      let shippingMessage = shippingThreshold
        ? `Free with $${shippingThreshold} order`
        : 'Free';
      return () => (
        <DefaultShipping
          iconType="success"
          shippingMessageStyle="shipping__success"
          shippingMessage={shippingMessage}
          shippingThreshold={shippingThreshold}
          displayQuantity={displayQuantity}
        />
      );
    }
    return () => (
      <DefaultShipping
        iconType="success"
        shippingMessage="Standard"
        displayQuantity={displayQuantity}
      />
    );
  }

  /* -----BODFS only----- */
  if (isBODFS(product) && !isSTH(product)) {
    // TODO: temporarily bypass same/next-day messaging for covid response
    /*
    if (isSameDayDelivery(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessageStyle="shipping__success"
          shippingMessage="Same-day"
          displayQuantity={displayQuantity}
        />
      );
    }
    if (isNextDayDelivery(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessageStyle="shipping__success"
          shippingMessage="Next-day"
          displayQuantity={displayQuantity}
        />
      );
    }
    */
    return () => (
      <DefaultShipping
        iconType="success"
        shippingMessage="Scheduled"
        displayQuantity={displayQuantity}
      />
    );
  }

  /* -----STH and BODFS----- */
  if (isBODFS(product) && isSTH(product)) {
    if (hasFreeShipping(product)) {
      return () => (
        <DefaultShipping
          iconType="success"
          shippingMessageStyle="shipping__success"
          shippingMessage="Free"
          displayQuantity={displayQuantity}
        />
      );
    }
    if (getThresholdShipping) {
      let shippingThreshold = shouldShowShippingThreshold(product, getThresholdShipping)
        ? getThresholdShipping : 0;
      let shippingMessage = shippingThreshold
        ? `Free with $${shippingThreshold} order`
        : 'Free';
      return () => (
        <DefaultShipping
          iconType="success"
          shippingMessageStyle="shipping__success"
          shippingMessage={shippingMessage}
          shippingThreshold={shippingThreshold}
          displayQuantity={displayQuantity}
        />
      );
    }
    return () => (
      <DefaultShipping
        iconType="success"
        shippingMessage="Standard"
        displayQuantity={displayQuantity}
      />
    );
  }

  /* -----not STH and not BODFS means no delivery to customer directly----- */
  if (!isBODFS() && !isSTH()) {
    if (isDiscontinued(product)) {
      return EmptyShippingMessage;
    }
    if (isOutOfStockOnline(product)) {
      return () => (
        <DefaultShipping
          shippingMessage="Unavailable"
        />
      );
    }
    return () => (
      <DefaultShipping
        shippingMessage="Unavailable"
      />
    );
  }

  return () => EmptyShippingMessage;
};

getShippingTemplate.dataModel = dataModel;
